// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export function uruguayanOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  return {
    country: 'uy',
    document_type: userInputValues['uruguayanDocumentType'],
    document: userInputValues['uruguayanDocument'],
    zipcode: userInputValues['uruguayanZipcode'],
    state: userInputValues['uruguayanState'],
    city: userInputValues['uruguayanCity'],
    address: userInputValues['uruguayanAddress'],
    street_number: userInputValues['uruguayanStreetNumber'],
    street_complement: userInputValues['uruguayanStreetComplement'],
    phone_number: userInputValues['uruguayanPhoneNumber'],
  };
}
